import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from "notistack";
import makeStyles from "@mui/styles/makeStyles";
import {
  Modal,
  Typography,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import ButtonBlue from "../../shared/buttonBlue";
import VehicleService from "../../../../services/vehicle.service";
import DriverService from "../../../../services/driver.service";
import SiteService from "../../../../services/site.service";
import { getDriverProfile } from "../../../../actions/driver";
import { getLocationAndVehicleUsage } from "../../../../actions/locationVehicle";

const useStyles = makeStyles((theme) => ({
  Modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    width: "250px",
    height: "150px",
  },
  Paper: {
    width: "500px",
    padding: "20px",
    boxShadow: 24,
  },
  Select: {
    width: "100%",
  },
  partOfTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  IconCar: {
    fontSize: "40px",
    marginRight: "10px",
    color: theme.palette.primary.main,
  },
  Title: {
    fontSize: "30px",
    color: theme.palette.primary.main,
  },
  Text: {
    fontSize: "15px",
  },
  partOfTitleName: {
    display: "flex",
    alignItems: "center",
  },

  partOfNavSwitch: {
    display: "flex",
    alignItems: "center",
  },
  partOfNavButton: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const ServiceTypeModal = ({ open, onClose, userId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [allServiceType, setAllServiceType] = useState([]);
  const [driverCurrentServiceType, setDriverCurrentServiceType] =
    useState(null);
  const [isSelectServiceType, setIsSelectServiceType] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const driverProfile = useSelector((state) => state.driverItem);
  const locationDriver = useSelector(
    (state) => state.locationVehicle
  );

  useEffect(() => {
    dispatch(getDriverProfile(userId));
    VehicleService.getAllServiceType().then((result) => {
      if (result.data?.length) {
        setAllServiceType(result.data);
      }
    });
    if (!locationDriver) dispatch(getLocationAndVehicleUsage(userId));
  }, [open]);

  useEffect(() => {
    if (driverProfile.result?.serviceType) {
      setDriverCurrentServiceType(driverProfile.result.ServiceTypeTH);
    }
  }, [driverProfile]);

  const {
    handleSubmit,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const selectedServiceType = watch("idServiceType", "");

  const addEndTime = async () => {
    // Add endtime to current vehicle using after the driver change type of service
    if (
      locationDriver.result &&
      locationDriver.result.length > 0 &&
      !locationDriver.result[0].endTime
    ) {
      const endTime = new Date().toISOString();

      await SiteService.setDeliverySampleLocationDriverByIdUsage({
        idUsage: locationDriver.result[0].idUsage,
        endTime: endTime,
      }).then((res) => {
        if (res.data) {
          enqueueSnackbar("สิ้นสุดการใช้งานรถรับส่งตัวอย่างสำเร็จ", {
            variant: "success",
          });
          dispatch(getLocationAndVehicleUsage(userId));
        } else {
          enqueueSnackbar("สิ้นสุดการใช้งานรถรับส่งตัวอย่างล้มเหลว", {
            variant: "error",
          });
        }
      });
    }
  };

  const onClickSubmit = () => {
    const selectedServiceType = getValues("idServiceType");

    DriverService.postDriverServiceType({
      idServiceType: selectedServiceType,
      idUser: userId,
    }).then((res) => {
      if (res.data[0]) {
        setDriverCurrentServiceType(res.data[0].serviceTypeTH);
        enqueueSnackbar("บันทึกข้อมูลสำเร็จ", { variant: "success" });
        setIsSelectServiceType(false);
      } else {
        enqueueSnackbar("บันทึกข้อมูลล้มเหลว", { variant: "error" });
      }
    });

    addEndTime();

  };

  const onClickStopService = () => {
    DriverService.postDriverServiceType({
      idServiceType: null,
      idUser: userId,
    }).then((res) => {
      if (res.data[0]) {
        setDriverCurrentServiceType(res.data[0].serviceTypeTH);
        enqueueSnackbar("สิ้นสุดการให้บริการสำเร็จ", { variant: "success" });
        setIsSelectServiceType(false);
      } else {
        enqueueSnackbar("สิ้นสุดการให้บริการล้มเหลว", { variant: "error" });
      }
    });

    addEndTime();
    
  };

  const onCloseModal = () => {
    setIsSelectServiceType(false);
    onClose();
  };

  const getImageSrc = () => {
    if (driverCurrentServiceType === "รถข้ามพื้นที่")
      return "/assets/Image/typeOfCars/CrossAreaCar.png";
    if (driverCurrentServiceType === "รถข้ามพื้นที่Pool")
      return "/assets/Image/typeOfCars/CrossAreaCarPool.png";
    if (driverCurrentServiceType === "รถในพื้นที่")
      return "/assets/Image/typeOfCars/InAreaCar.png";
    if (driverCurrentServiceType === "รถระหว่างไซต์")
      return "/assets/Image/typeOfCars/BetweenSiteCar.png";
    if (driverCurrentServiceType === "รถรับส่งเพื่อน")
      return "/assets/Image/typeOfCars/Friend2FriendCar.png";
    if (driverCurrentServiceType === "รถรับส่งของ")
      return "/assets/Image/typeOfCars/DeliveryItemCar.png";
    if (driverCurrentServiceType === "รถรับส่งตัวอย่าง")
      return "/assets/Image/typeOfCars/sampleshuttle.png";
    if (driverCurrentServiceType === "รถรับส่ง")
      return "/assets/Image/typeOfCars/transparent_ShiftCar.png";
    return "/assets/Image/friend2friend/driver.png";
  };

  return (
    driverProfile.result && (
      <Modal
        className={`${classes.Modal}`}
        open={open}
        onClose={onCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Paper className={`${classes.Paper}`}>
          <Grid container>
            {driverCurrentServiceType && !isSelectServiceType && (
              <Grid
                item
                xs={12}
                sm={12}
                style={{
                  padding: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <Typography className={`${classes.Title}`}>
                  คุณกำลังให้บริการ: {driverCurrentServiceType}
                </Typography>
                <img
                  style={{ width: "250px" }}
                  src={getImageSrc()}
                  alt="Service Type"
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <ButtonBlue
                    variant="contained"
                    onClick={() => {
                      setIsSelectServiceType(true);
                    }}
                  >
                    เปลี่ยนประเภทบริการ
                  </ButtonBlue>
                  <ButtonBlue
                    variant="contained"
                    customColor="#F44336"
                    sx={{
                      "&:hover": {
                        borderColor: "#d9392e",
                        backgroundColor: "#d9392e",
                      },
                    }}
                    onClick={onClickStopService}
                  >
                    สิ้นสุดการให้บริการ
                  </ButtonBlue>
                </div>
              </Grid>
            )}
            {(isSelectServiceType || !driverCurrentServiceType) && (
              <Grid item xs={12} sm={12}>
                <div className={`${classes.partOfTitle}`}>
                  <div className={`${classes.partOfTitleName}`}>
                    <Typography className={`${classes.Title}`}>
                      เลือกประเภทงานที่กำลังให้บริการ
                    </Typography>
                  </div>
                </div>
                {/* <form> */}
                <form onSubmit={handleSubmit(onClickSubmit)}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="idVehicle">
                      ประเภทงานที่กำลังให้บริการ
                    </InputLabel>
                    <Controller
                      render={(propsInController) => (
                        <Select
                          labelId="idServiceType"
                          id="idServiceType"
                          value={propsInController.field.value || ""}
                          onChange={(event) => {
                            propsInController.field.onChange(event);
                          }}
                          label="ประเภทงานที่กำลังให้บริการ"
                        >
                          {allServiceType &&
                            allServiceType.map((service) => (
                              <MenuItem
                                key={service.idServiceType}
                                value={service.idServiceType}
                              >
                                {service.ServiceTypeTH}
                              </MenuItem>
                            ))}
                        </Select>
                      )}
                      name="idServiceType"
                      control={control}
                      defaultValue={driverProfile.result.serviceType || ""}
                    />
                  </FormControl>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "16px",
                      gap: "10px",
                    }}
                  >
                    <ButtonBlue
                      variant="contained"
                      type="submit"
                      disabled={!selectedServiceType}
                    >
                      ยืนยัน
                    </ButtonBlue>
                    <ButtonBlue
                      variant="contained"
                      onClick={onCloseModal}
                      customColor="#F44336"
                      sx={{
                        "&:hover": {
                          borderColor: "#d9392e",
                          backgroundColor: "#d9392e",
                        },
                      }}
                    >
                      ยกเลิก
                    </ButtonBlue>
                  </div>
                </form>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Modal>
    )
  );
};

export default ServiceTypeModal;
